const firebaseConfig = {
  apiKey: "AIzaSyCO6nc4j2bn7yoDkpjPquKtXxfuvFmsaLk",
  authDomain: "afta-wallet.firebaseapp.com",
  projectId: "afta-wallet",
  storageBucket: "afta-wallet.appspot.com",
  messagingSenderId: "659194799160",
  appId: "1:659194799160:web:02511b30d0b36fa21472cd",
  measurementId: "G-ZMK5KFWK0N"
};

export default firebaseConfig;
